import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { checkEnumValue } from '@/helpers/checkEnumValue'

import type { SortDirection, SortParams, SortState } from './types.ts'

export const useSortQuery = <SortKey extends string, SortDir extends SortDirection>(
  sortByEnum: Record<string, SortKey>,
  sortDirectionEnum: Record<string, SortDir>,
) => {
  const route = useRoute()
  const router = useRouter()

  const sortBy = ref(checkEnumValue(route.query.sortBy, sortByEnum, undefined))
  const sortDirection = ref(checkEnumValue(route.query.sortDirection, sortDirectionEnum, undefined))

  watch(
    () => route.query,
    () => {
      sortBy.value = checkEnumValue(route.query.sortBy, sortByEnum, undefined)
      sortDirection.value = checkEnumValue(route.query.sortDirection, sortDirectionEnum, undefined)
    },
  )

  function setSort(params: SortParams<SortKey, SortDir>) {
    const query = { ...route.query, sortBy: params.sortBy, sortDirection: params.sortDirection, page: undefined }
    router.push({ query })
  }

  function getSortState(key: SortKey): SortState<SortKey, SortDir> {
    let direction
    if (sortBy.value && sortBy.value === key) {
      direction = sortDirection.value
    }

    return {
      active: sortBy.value === key,
      sortBy: key,
      sortDirection: direction,
    }
  }

  return {
    sortBy,
    sortDirection,
    setSort,
    getSortState,
  }
}
